export enum AnalyticsEvent {
    REDITECTED_FROM_BETA_TO_PLATFORM = 'Redirected from beta to platform',

    SMART_REPLIES_VIEWED = 'Smart replies viewed',
    SMART_REPLY_SELECTED = 'Smart reply selected',

    ARCHIVED_CONVERSATIONS_VIEWED = 'Archived conversations viewed',
    LEAD_ARCHIVE_STATUS_CHANGED = 'Lead archive status changed',

    NOTIFICATION_ALERT_DISMISSED = 'Notification alert dismissed',
    NOTIFICATION_REQUEST_DENIED = 'Notification request denied',
    NOTIFICATION_REQUEST_GRANTED = 'Notification request granted',

    SHORTCUT_KEY_USED = 'Shortcut key used',
    BUTTON_CLICKED = 'Button clicked',

    VACANT_PROPERTIES_NOTIFICATIONS_DISMISSED = 'Vacant properties notifications dismissed',


    USED_SMART_NOTIFICATION_OPEN_SMART_REPLIES = 'User opened smart replies from smart notification',
    USED_SMART_NOTIFICATION_CHANGE_STAGE = 'User changed lead stage from smart notification',
    USED_SMART_NOTIFICATION_OPEN_SNIPPETS = 'User opened snippets from smart notification',
    USED_SMART_NOTIFICATION_SCHEDULE_TOUR = 'User opened schedule tour modal from smart notification',

    INVITE_TO_TOUR_CLICKED = 'Invite to tour button clicked',
    INVITE_TO_APPLY_CLICKED = 'Invite to apply button clicked',

    CUSTOM_DATE_RANGE_SELECTED = 'Custom date range selected',
    CUSTOM_DATE_RANGE_SAVED = 'Custom date range saved',
    CUSTOM_DATE_RANGE_CANCELLED = 'Custom date range cancelled',

    CLICIKED_ON_GO_TO_PROPERTIES_IN_VACANT_ALERT = 'Clicked on go to properties in vacant properties alert',
    CLICKED_ON_DISMISS_VACANT_ALERT = 'Clicked on dismiss vacant properties alert',

    CLICKED_CONFIRM_TOUR = 'Clicked confirm tour',
    CLICKED_CANCEL_TOUR = 'Clicked cancel tour',

    ONBOARDING_BULK_IMPORT_PROPERTIES_CLICKED = 'Onboarding bulk import properties button clicked',
    ONBOARDING_BULK_IMPORT_LEADS_CLICKED = 'Onboarding bulk import leads button clicked',

    LOCAL_INBOX_SEARCH = 'Local inbox search',

    LEADS_GROUP_BY_SELECTED = 'Leads group by selected',
    CONVERSATIONS_GROUP_BY_PROPERTY_SELECTED = 'Conversations group by property selected',
    LEADS_CONTACT_INFO_COPIED = 'Leads contact info copied',
    LEADS_SEARCHED = 'Leads searched',

    ANALYTICS_TAB_CLICKED = 'Analytics tab clicked',
    ANALYTICS_DATE_RANGE_CHANGED = 'Analytics date range changed',
    ANALYTICS_PROPERTY_LABEL_FILTER_CHANGED = 'Analytics property label filter changed',
    ANALYTICS_PROPERTY_FILTER_CHANGED = 'Analytics property filter changed',
    ANALYTICS_SOURCE_FILTER_CHANGED = 'Analytics source filter changed',

    ROUND_ROBIN_LEAD_ROUTING_RULE_CREATED = 'Round Robin lead routing rule created',
    ROUND_ROBIN_LEAD_ROUTING_RULE_UPDATED = 'Round Robin lead routing rule updated',

    MATCH_OR_NOT_SPAM_BUTTON_CLICKED = 'User clicked match or not spam button for an unmatched listing',

    CLICKED_SHARE_LEAD = 'Clicked share lead',
    COPIED_LEAD_TO_CLIPBOARD = 'Copied lead details to clipboard',

    SEARCH_TOUR = 'Search tour',
    TOUR_FILTER_SET = 'Tour filter set',

    SNIPPET_LIBRARY_ADD_CLICKED = 'Snippet library add clicked',
    SNIPPET_LIBRARY_DELETE_CLICKED = 'Snippet library delete clicked',
    SNIPPET_LIBRARY_SEARCHED = 'Snippet library searched',
    SNIPPET_LIBRARY_CATEGORY_FILTERED = 'Snippet library category filtered',
}
